import { DomainFilterType } from "src/app/model/enum/observations/domain-filter-type.enum";
import { Subdomain } from "src/app/model/enum/observations/subdomain.enum";
import { ACTION_PLAN_TAB } from "src/app/observations/ntpe/ntpe-details/ntpe-details.component";
import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const NtpeLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates,
    ntpeDashboard: LazyLoadedStates,
    ntpeDashboardView: LazyLoadedStates,
    ntpeDetails: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.user-summary.ntpe',
        url: '/ntpe',
        abstract: true
    },
    ntpeDashboard: {
        name: 'authenticated.user-summary.ntpe.dashboard',
        url: '/dashboard/:userId/:observationId',
        abstract: true,
    },
    ntpeDashboardView: {
        name: 'authenticated.user-summary.ntpe.dashboard.view',
        url: '/view',
    },
    ntpeDetails: {
        name: 'authenticated.user-summary.ntpe.details',
        url: '/details/:userId/:observationId/?:tabIndex?filterType&currentRubricComponent&showTargetUser',
        params: {
            tabIndex: {
                raw: true,
                dynamic: true,
                type: 'int',
                value: ACTION_PLAN_TAB
            },
            filterType: {
                raw: true,
                dynamic: true,
                type: 'int',
                value: DomainFilterType.FOCUS_AREAS
            },
            currentRubricComponent: {
                raw: true,
                dynamic: true,
                type: 'string',
                value: Subdomain.CONTENT_KNOWLEDGE
            },
            showTargetUser: {
                raw: true,
                dynamic: true,
                type: 'bool'
            }
        },
    }
}, () => import('src/app/observations/ntpe/ntpe.module')
    .then((result: { NtpeModule: any }) => result.NtpeModule)
);
